export default {
  title: "Hunter pets",
  content: [
    "Bears can now also learn Swipe, which deals mediocre damage in a frontal cone.",
    "Crocolisks, Hyenas and Raptors can now learn Crushing Jaw, which has a 100% crit chance and 25 sec cooldown.",
    "Spiders can now also learn Spider Poison, which has the same effect as Scorpid Poison.",
    "Crabs can now also learn Shell Shield.",
    "Tallstriders can now also learn Screech.",
  ],
};
